var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDots(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 226,
    height: 226,
    viewBox: "0 0 226 226",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.03571 8.07143C6.26458 8.07143 8.07143 6.26458 8.07143 4.03571C8.07143 1.80685 6.26458 0 4.03571 0C1.80685 0 0 1.80685 0 4.03571C0 6.26458 1.80685 8.07143 4.03571 8.07143Z",
    fill: "#E6E6E6",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2496 8.07143C30.4784 8.07143 32.2853 6.26458 32.2853 4.03571C32.2853 1.80685 30.4784 0 28.2496 0C26.0207 0 24.2139 1.80685 24.2139 4.03571C24.2139 6.26458 26.0207 8.07143 28.2496 8.07143Z",
    fill: "#E6E6E6",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.4644 8.07143C54.6933 8.07143 56.5001 6.26458 56.5001 4.03571C56.5001 1.80685 54.6933 0 52.4644 0C50.2356 0 48.4287 1.80685 48.4287 4.03571C48.4287 6.26458 50.2356 8.07143 52.4644 8.07143Z",
    fill: "#E6E6E6",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.6783 8.07143C78.9072 8.07143 80.714 6.26458 80.714 4.03571C80.714 1.80685 78.9072 0 76.6783 0C74.4494 0 72.6426 1.80685 72.6426 4.03571C72.6426 6.26458 74.4494 8.07143 76.6783 8.07143Z",
    fill: "#E6E6E6",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.893 8.07143C103.122 8.07143 104.929 6.26458 104.929 4.03571C104.929 1.80685 103.122 0 100.893 0C98.6643 0 96.8574 1.80685 96.8574 4.03571C96.8574 6.26458 98.6643 8.07143 100.893 8.07143Z",
    fill: "#E6E6E6",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.107 8.07143C127.336 8.07143 129.143 6.26458 129.143 4.03571C129.143 1.80685 127.336 0 125.107 0C122.878 0 121.071 1.80685 121.071 4.03571C121.071 6.26458 122.878 8.07143 125.107 8.07143Z",
    fill: "#E6E6E6",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.322 8.07143C151.551 8.07143 153.358 6.26458 153.358 4.03571C153.358 1.80685 151.551 0 149.322 0C147.093 0 145.286 1.80685 145.286 4.03571C145.286 6.26458 147.093 8.07143 149.322 8.07143Z",
    fill: "#E6E6E6",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.536 8.07143C175.765 8.07143 177.571 6.26458 177.571 4.03571C177.571 1.80685 175.765 0 173.536 0C171.307 0 169.5 1.80685 169.5 4.03571C169.5 6.26458 171.307 8.07143 173.536 8.07143Z",
    fill: "#E6E6E6",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.75 8.07143C199.978 8.07143 201.785 6.26458 201.785 4.03571C201.785 1.80685 199.978 0 197.75 0C195.521 0 193.714 1.80685 193.714 4.03571C193.714 6.26458 195.521 8.07143 197.75 8.07143Z",
    fill: "#E6E6E6",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.964 8.07143C224.193 8.07143 226 6.26458 226 4.03571C226 1.80685 224.193 0 221.964 0C219.736 0 217.929 1.80685 217.929 4.03571C217.929 6.26458 219.736 8.07143 221.964 8.07143Z",
    fill: "#E6E6E6",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.03571 32.2858C6.26458 32.2858 8.07143 30.4789 8.07143 28.2501C8.07143 26.0212 6.26458 24.2144 4.03571 24.2144C1.80685 24.2144 0 26.0212 0 28.2501C0 30.4789 1.80685 32.2858 4.03571 32.2858Z",
    fill: "#E6E6E6",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2496 32.2858C30.4784 32.2858 32.2853 30.4789 32.2853 28.2501C32.2853 26.0212 30.4784 24.2144 28.2496 24.2144C26.0207 24.2144 24.2139 26.0212 24.2139 28.2501C24.2139 30.4789 26.0207 32.2858 28.2496 32.2858Z",
    fill: "#E6E6E6",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.4644 32.2858C54.6933 32.2858 56.5001 30.4789 56.5001 28.2501C56.5001 26.0212 54.6933 24.2144 52.4644 24.2144C50.2356 24.2144 48.4287 26.0212 48.4287 28.2501C48.4287 30.4789 50.2356 32.2858 52.4644 32.2858Z",
    fill: "#E6E6E6",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.6783 32.2858C78.9072 32.2858 80.714 30.4789 80.714 28.2501C80.714 26.0212 78.9072 24.2144 76.6783 24.2144C74.4494 24.2144 72.6426 26.0212 72.6426 28.2501C72.6426 30.4789 74.4494 32.2858 76.6783 32.2858Z",
    fill: "#E6E6E6",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.893 32.2858C103.122 32.2858 104.929 30.4789 104.929 28.2501C104.929 26.0212 103.122 24.2144 100.893 24.2144C98.6643 24.2144 96.8574 26.0212 96.8574 28.2501C96.8574 30.4789 98.6643 32.2858 100.893 32.2858Z",
    fill: "#E6E6E6",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.107 32.2858C127.336 32.2858 129.143 30.4789 129.143 28.2501C129.143 26.0212 127.336 24.2144 125.107 24.2144C122.878 24.2144 121.071 26.0212 121.071 28.2501C121.071 30.4789 122.878 32.2858 125.107 32.2858Z",
    fill: "#E6E6E6",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.322 32.2858C151.551 32.2858 153.358 30.4789 153.358 28.2501C153.358 26.0212 151.551 24.2144 149.322 24.2144C147.093 24.2144 145.286 26.0212 145.286 28.2501C145.286 30.4789 147.093 32.2858 149.322 32.2858Z",
    fill: "#E6E6E6",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.536 32.2858C175.765 32.2858 177.571 30.4789 177.571 28.2501C177.571 26.0212 175.765 24.2144 173.536 24.2144C171.307 24.2144 169.5 26.0212 169.5 28.2501C169.5 30.4789 171.307 32.2858 173.536 32.2858Z",
    fill: "#E6E6E6",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.75 32.2858C199.978 32.2858 201.785 30.4789 201.785 28.2501C201.785 26.0212 199.978 24.2144 197.75 24.2144C195.521 24.2144 193.714 26.0212 193.714 28.2501C193.714 30.4789 195.521 32.2858 197.75 32.2858Z",
    fill: "#E6E6E6",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.964 32.2858C224.193 32.2858 226 30.4789 226 28.2501C226 26.0212 224.193 24.2144 221.964 24.2144C219.736 24.2144 217.929 26.0212 217.929 28.2501C217.929 30.4789 219.736 32.2858 221.964 32.2858Z",
    fill: "#E6E6E6",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.03571 56.4999C6.26458 56.4999 8.07143 54.6931 8.07143 52.4642C8.07143 50.2353 6.26458 48.4285 4.03571 48.4285C1.80685 48.4285 0 50.2353 0 52.4642C0 54.6931 1.80685 56.4999 4.03571 56.4999Z",
    fill: "#E6E6E6",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2496 56.4999C30.4784 56.4999 32.2853 54.6931 32.2853 52.4642C32.2853 50.2353 30.4784 48.4285 28.2496 48.4285C26.0207 48.4285 24.2139 50.2353 24.2139 52.4642C24.2139 54.6931 26.0207 56.4999 28.2496 56.4999Z",
    fill: "#E6E6E6",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.4644 56.4999C54.6933 56.4999 56.5001 54.6931 56.5001 52.4642C56.5001 50.2353 54.6933 48.4285 52.4644 48.4285C50.2356 48.4285 48.4287 50.2353 48.4287 52.4642C48.4287 54.6931 50.2356 56.4999 52.4644 56.4999Z",
    fill: "#E6E6E6",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.6783 56.4999C78.9072 56.4999 80.714 54.6931 80.714 52.4642C80.714 50.2353 78.9072 48.4285 76.6783 48.4285C74.4494 48.4285 72.6426 50.2353 72.6426 52.4642C72.6426 54.6931 74.4494 56.4999 76.6783 56.4999Z",
    fill: "#E6E6E6",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.893 56.4999C103.122 56.4999 104.929 54.6931 104.929 52.4642C104.929 50.2353 103.122 48.4285 100.893 48.4285C98.6643 48.4285 96.8574 50.2353 96.8574 52.4642C96.8574 54.6931 98.6643 56.4999 100.893 56.4999Z",
    fill: "#E6E6E6",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.107 56.4999C127.336 56.4999 129.143 54.6931 129.143 52.4642C129.143 50.2353 127.336 48.4285 125.107 48.4285C122.878 48.4285 121.071 50.2353 121.071 52.4642C121.071 54.6931 122.878 56.4999 125.107 56.4999Z",
    fill: "#E6E6E6",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.322 56.4999C151.551 56.4999 153.358 54.6931 153.358 52.4642C153.358 50.2353 151.551 48.4285 149.322 48.4285C147.093 48.4285 145.286 50.2353 145.286 52.4642C145.286 54.6931 147.093 56.4999 149.322 56.4999Z",
    fill: "#E6E6E6",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.536 56.4999C175.765 56.4999 177.571 54.6931 177.571 52.4642C177.571 50.2353 175.765 48.4285 173.536 48.4285C171.307 48.4285 169.5 50.2353 169.5 52.4642C169.5 54.6931 171.307 56.4999 173.536 56.4999Z",
    fill: "#E6E6E6",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.75 56.4999C199.978 56.4999 201.785 54.6931 201.785 52.4642C201.785 50.2353 199.978 48.4285 197.75 48.4285C195.521 48.4285 193.714 50.2353 193.714 52.4642C193.714 54.6931 195.521 56.4999 197.75 56.4999Z",
    fill: "#E6E6E6",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.964 56.4999C224.193 56.4999 226 54.6931 226 52.4642C226 50.2353 224.193 48.4285 221.964 48.4285C219.736 48.4285 217.929 50.2353 217.929 52.4642C217.929 54.6931 219.736 56.4999 221.964 56.4999Z",
    fill: "#E6E6E6",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.03571 80.7142C6.26458 80.7142 8.07143 78.9074 8.07143 76.6785C8.07143 74.4497 6.26458 72.6428 4.03571 72.6428C1.80685 72.6428 0 74.4497 0 76.6785C0 78.9074 1.80685 80.7142 4.03571 80.7142Z",
    fill: "#E6E6E6",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2496 80.7142C30.4784 80.7142 32.2853 78.9074 32.2853 76.6785C32.2853 74.4497 30.4784 72.6428 28.2496 72.6428C26.0207 72.6428 24.2139 74.4497 24.2139 76.6785C24.2139 78.9074 26.0207 80.7142 28.2496 80.7142Z",
    fill: "#E6E6E6",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.4644 80.7142C54.6933 80.7142 56.5001 78.9074 56.5001 76.6785C56.5001 74.4497 54.6933 72.6428 52.4644 72.6428C50.2356 72.6428 48.4287 74.4497 48.4287 76.6785C48.4287 78.9074 50.2356 80.7142 52.4644 80.7142Z",
    fill: "#E6E6E6",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.6783 80.7142C78.9072 80.7142 80.714 78.9074 80.714 76.6785C80.714 74.4497 78.9072 72.6428 76.6783 72.6428C74.4494 72.6428 72.6426 74.4497 72.6426 76.6785C72.6426 78.9074 74.4494 80.7142 76.6783 80.7142Z",
    fill: "#E6E6E6",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.893 80.7142C103.122 80.7142 104.929 78.9074 104.929 76.6785C104.929 74.4497 103.122 72.6428 100.893 72.6428C98.6643 72.6428 96.8574 74.4497 96.8574 76.6785C96.8574 78.9074 98.6643 80.7142 100.893 80.7142Z",
    fill: "#E6E6E6",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.107 80.7142C127.336 80.7142 129.143 78.9074 129.143 76.6785C129.143 74.4497 127.336 72.6428 125.107 72.6428C122.878 72.6428 121.071 74.4497 121.071 76.6785C121.071 78.9074 122.878 80.7142 125.107 80.7142Z",
    fill: "#E6E6E6",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.322 80.7142C151.551 80.7142 153.358 78.9074 153.358 76.6785C153.358 74.4497 151.551 72.6428 149.322 72.6428C147.093 72.6428 145.286 74.4497 145.286 76.6785C145.286 78.9074 147.093 80.7142 149.322 80.7142Z",
    fill: "#E6E6E6",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.536 80.7142C175.765 80.7142 177.571 78.9074 177.571 76.6785C177.571 74.4497 175.765 72.6428 173.536 72.6428C171.307 72.6428 169.5 74.4497 169.5 76.6785C169.5 78.9074 171.307 80.7142 173.536 80.7142Z",
    fill: "#E6E6E6",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.75 80.7142C199.978 80.7142 201.785 78.9074 201.785 76.6785C201.785 74.4497 199.978 72.6428 197.75 72.6428C195.521 72.6428 193.714 74.4497 193.714 76.6785C193.714 78.9074 195.521 80.7142 197.75 80.7142Z",
    fill: "#E6E6E6",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.964 80.7142C224.193 80.7142 226 78.9074 226 76.6785C226 74.4497 224.193 72.6428 221.964 72.6428C219.736 72.6428 217.929 74.4497 217.929 76.6785C217.929 78.9074 219.736 80.7142 221.964 80.7142Z",
    fill: "#E6E6E6",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.03571 104.929C6.26458 104.929 8.07143 103.122 8.07143 100.893C8.07143 98.664 6.26458 96.8572 4.03571 96.8572C1.80685 96.8572 0 98.664 0 100.893C0 103.122 1.80685 104.929 4.03571 104.929Z",
    fill: "#E6E6E6",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2496 104.929C30.4784 104.929 32.2853 103.122 32.2853 100.893C32.2853 98.664 30.4784 96.8572 28.2496 96.8572C26.0207 96.8572 24.2139 98.664 24.2139 100.893C24.2139 103.122 26.0207 104.929 28.2496 104.929Z",
    fill: "#E6E6E6",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.4644 104.929C54.6933 104.929 56.5001 103.122 56.5001 100.893C56.5001 98.664 54.6933 96.8572 52.4644 96.8572C50.2356 96.8572 48.4287 98.664 48.4287 100.893C48.4287 103.122 50.2356 104.929 52.4644 104.929Z",
    fill: "#E6E6E6",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.6783 104.929C78.9072 104.929 80.714 103.122 80.714 100.893C80.714 98.664 78.9072 96.8572 76.6783 96.8572C74.4494 96.8572 72.6426 98.664 72.6426 100.893C72.6426 103.122 74.4494 104.929 76.6783 104.929Z",
    fill: "#E6E6E6",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.893 104.929C103.122 104.929 104.929 103.122 104.929 100.893C104.929 98.664 103.122 96.8572 100.893 96.8572C98.6643 96.8572 96.8574 98.664 96.8574 100.893C96.8574 103.122 98.6643 104.929 100.893 104.929Z",
    fill: "#E6E6E6",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.107 104.929C127.336 104.929 129.143 103.122 129.143 100.893C129.143 98.664 127.336 96.8572 125.107 96.8572C122.878 96.8572 121.071 98.664 121.071 100.893C121.071 103.122 122.878 104.929 125.107 104.929Z",
    fill: "#E6E6E6",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.322 104.929C151.551 104.929 153.358 103.122 153.358 100.893C153.358 98.664 151.551 96.8572 149.322 96.8572C147.093 96.8572 145.286 98.664 145.286 100.893C145.286 103.122 147.093 104.929 149.322 104.929Z",
    fill: "#E6E6E6",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.536 104.929C175.765 104.929 177.571 103.122 177.571 100.893C177.571 98.664 175.765 96.8572 173.536 96.8572C171.307 96.8572 169.5 98.664 169.5 100.893C169.5 103.122 171.307 104.929 173.536 104.929Z",
    fill: "#E6E6E6",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.75 104.929C199.978 104.929 201.785 103.122 201.785 100.893C201.785 98.664 199.978 96.8572 197.75 96.8572C195.521 96.8572 193.714 98.664 193.714 100.893C193.714 103.122 195.521 104.929 197.75 104.929Z",
    fill: "#E6E6E6",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.964 104.929C224.193 104.929 226 103.122 226 100.893C226 98.664 224.193 96.8572 221.964 96.8572C219.736 96.8572 217.929 98.664 217.929 100.893C217.929 103.122 219.736 104.929 221.964 104.929Z",
    fill: "#E6E6E6",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.03571 129.143C6.26458 129.143 8.07143 127.336 8.07143 125.107C8.07143 122.878 6.26458 121.072 4.03571 121.072C1.80685 121.072 0 122.878 0 125.107C0 127.336 1.80685 129.143 4.03571 129.143Z",
    fill: "#E6E6E6",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2496 129.143C30.4784 129.143 32.2853 127.336 32.2853 125.107C32.2853 122.878 30.4784 121.072 28.2496 121.072C26.0207 121.072 24.2139 122.878 24.2139 125.107C24.2139 127.336 26.0207 129.143 28.2496 129.143Z",
    fill: "#E6E6E6",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.4644 129.143C54.6933 129.143 56.5001 127.336 56.5001 125.107C56.5001 122.878 54.6933 121.072 52.4644 121.072C50.2356 121.072 48.4287 122.878 48.4287 125.107C48.4287 127.336 50.2356 129.143 52.4644 129.143Z",
    fill: "#E6E6E6",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.6783 129.143C78.9072 129.143 80.714 127.336 80.714 125.107C80.714 122.878 78.9072 121.072 76.6783 121.072C74.4494 121.072 72.6426 122.878 72.6426 125.107C72.6426 127.336 74.4494 129.143 76.6783 129.143Z",
    fill: "#E6E6E6",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.893 129.143C103.122 129.143 104.929 127.336 104.929 125.107C104.929 122.878 103.122 121.072 100.893 121.072C98.6643 121.072 96.8574 122.878 96.8574 125.107C96.8574 127.336 98.6643 129.143 100.893 129.143Z",
    fill: "#E6E6E6",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.107 129.143C127.336 129.143 129.143 127.336 129.143 125.107C129.143 122.878 127.336 121.072 125.107 121.072C122.878 121.072 121.071 122.878 121.071 125.107C121.071 127.336 122.878 129.143 125.107 129.143Z",
    fill: "#E6E6E6",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.322 129.143C151.551 129.143 153.358 127.336 153.358 125.107C153.358 122.878 151.551 121.072 149.322 121.072C147.093 121.072 145.286 122.878 145.286 125.107C145.286 127.336 147.093 129.143 149.322 129.143Z",
    fill: "#E6E6E6",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.536 129.143C175.765 129.143 177.571 127.336 177.571 125.107C177.571 122.878 175.765 121.072 173.536 121.072C171.307 121.072 169.5 122.878 169.5 125.107C169.5 127.336 171.307 129.143 173.536 129.143Z",
    fill: "#E6E6E6",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.75 129.143C199.978 129.143 201.785 127.336 201.785 125.107C201.785 122.878 199.978 121.072 197.75 121.072C195.521 121.072 193.714 122.878 193.714 125.107C193.714 127.336 195.521 129.143 197.75 129.143Z",
    fill: "#E6E6E6",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.964 129.143C224.193 129.143 226 127.336 226 125.107C226 122.878 224.193 121.072 221.964 121.072C219.736 121.072 217.929 122.878 217.929 125.107C217.929 127.336 219.736 129.143 221.964 129.143Z",
    fill: "#E6E6E6",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.03571 153.357C6.26458 153.357 8.07143 151.55 8.07143 149.321C8.07143 147.092 6.26458 145.286 4.03571 145.286C1.80685 145.286 0 147.092 0 149.321C0 151.55 1.80685 153.357 4.03571 153.357Z",
    fill: "#E6E6E6",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2496 153.357C30.4784 153.357 32.2853 151.55 32.2853 149.321C32.2853 147.092 30.4784 145.286 28.2496 145.286C26.0207 145.286 24.2139 147.092 24.2139 149.321C24.2139 151.55 26.0207 153.357 28.2496 153.357Z",
    fill: "#E6E6E6",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.4644 153.357C54.6933 153.357 56.5001 151.55 56.5001 149.321C56.5001 147.092 54.6933 145.286 52.4644 145.286C50.2356 145.286 48.4287 147.092 48.4287 149.321C48.4287 151.55 50.2356 153.357 52.4644 153.357Z",
    fill: "#E6E6E6",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.6783 153.357C78.9072 153.357 80.714 151.55 80.714 149.321C80.714 147.092 78.9072 145.286 76.6783 145.286C74.4494 145.286 72.6426 147.092 72.6426 149.321C72.6426 151.55 74.4494 153.357 76.6783 153.357Z",
    fill: "#E6E6E6",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.893 153.357C103.122 153.357 104.929 151.55 104.929 149.321C104.929 147.092 103.122 145.286 100.893 145.286C98.6643 145.286 96.8574 147.092 96.8574 149.321C96.8574 151.55 98.6643 153.357 100.893 153.357Z",
    fill: "#E6E6E6",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.107 153.357C127.336 153.357 129.143 151.55 129.143 149.321C129.143 147.092 127.336 145.286 125.107 145.286C122.878 145.286 121.071 147.092 121.071 149.321C121.071 151.55 122.878 153.357 125.107 153.357Z",
    fill: "#E6E6E6",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.322 153.357C151.551 153.357 153.358 151.55 153.358 149.321C153.358 147.092 151.551 145.286 149.322 145.286C147.093 145.286 145.286 147.092 145.286 149.321C145.286 151.55 147.093 153.357 149.322 153.357Z",
    fill: "#E6E6E6",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.536 153.357C175.765 153.357 177.571 151.55 177.571 149.321C177.571 147.092 175.765 145.286 173.536 145.286C171.307 145.286 169.5 147.092 169.5 149.321C169.5 151.55 171.307 153.357 173.536 153.357Z",
    fill: "#E6E6E6",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.75 153.357C199.978 153.357 201.785 151.55 201.785 149.321C201.785 147.092 199.978 145.286 197.75 145.286C195.521 145.286 193.714 147.092 193.714 149.321C193.714 151.55 195.521 153.357 197.75 153.357Z",
    fill: "#E6E6E6",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.964 153.357C224.193 153.357 226 151.55 226 149.321C226 147.092 224.193 145.286 221.964 145.286C219.736 145.286 217.929 147.092 217.929 149.321C217.929 151.55 219.736 153.357 221.964 153.357Z",
    fill: "#E6E6E6",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.03571 177.571C6.26458 177.571 8.07143 175.765 8.07143 173.536C8.07143 171.307 6.26458 169.5 4.03571 169.5C1.80685 169.5 0 171.307 0 173.536C0 175.765 1.80685 177.571 4.03571 177.571Z",
    fill: "#E6E6E6",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2496 177.571C30.4784 177.571 32.2853 175.765 32.2853 173.536C32.2853 171.307 30.4784 169.5 28.2496 169.5C26.0207 169.5 24.2139 171.307 24.2139 173.536C24.2139 175.765 26.0207 177.571 28.2496 177.571Z",
    fill: "#E6E6E6",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.4644 177.571C54.6933 177.571 56.5001 175.765 56.5001 173.536C56.5001 171.307 54.6933 169.5 52.4644 169.5C50.2356 169.5 48.4287 171.307 48.4287 173.536C48.4287 175.765 50.2356 177.571 52.4644 177.571Z",
    fill: "#E6E6E6",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.6783 177.571C78.9072 177.571 80.714 175.765 80.714 173.536C80.714 171.307 78.9072 169.5 76.6783 169.5C74.4494 169.5 72.6426 171.307 72.6426 173.536C72.6426 175.765 74.4494 177.571 76.6783 177.571Z",
    fill: "#E6E6E6",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.893 177.571C103.122 177.571 104.929 175.765 104.929 173.536C104.929 171.307 103.122 169.5 100.893 169.5C98.6643 169.5 96.8574 171.307 96.8574 173.536C96.8574 175.765 98.6643 177.571 100.893 177.571Z",
    fill: "#E6E6E6",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.107 177.571C127.336 177.571 129.143 175.765 129.143 173.536C129.143 171.307 127.336 169.5 125.107 169.5C122.878 169.5 121.071 171.307 121.071 173.536C121.071 175.765 122.878 177.571 125.107 177.571Z",
    fill: "#E6E6E6",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.322 177.571C151.551 177.571 153.358 175.765 153.358 173.536C153.358 171.307 151.551 169.5 149.322 169.5C147.093 169.5 145.286 171.307 145.286 173.536C145.286 175.765 147.093 177.571 149.322 177.571Z",
    fill: "#E6E6E6",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.536 177.571C175.765 177.571 177.571 175.765 177.571 173.536C177.571 171.307 175.765 169.5 173.536 169.5C171.307 169.5 169.5 171.307 169.5 173.536C169.5 175.765 171.307 177.571 173.536 177.571Z",
    fill: "#E6E6E6",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.75 177.571C199.978 177.571 201.785 175.765 201.785 173.536C201.785 171.307 199.978 169.5 197.75 169.5C195.521 169.5 193.714 171.307 193.714 173.536C193.714 175.765 195.521 177.571 197.75 177.571Z",
    fill: "#E6E6E6",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.964 177.571C224.193 177.571 226 175.765 226 173.536C226 171.307 224.193 169.5 221.964 169.5C219.736 169.5 217.929 171.307 217.929 173.536C217.929 175.765 219.736 177.571 221.964 177.571Z",
    fill: "#E6E6E6",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.03571 201.786C6.26458 201.786 8.07143 199.979 8.07143 197.75C8.07143 195.521 6.26458 193.714 4.03571 193.714C1.80685 193.714 0 195.521 0 197.75C0 199.979 1.80685 201.786 4.03571 201.786Z",
    fill: "#E6E6E6",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2496 201.786C30.4784 201.786 32.2853 199.979 32.2853 197.75C32.2853 195.521 30.4784 193.714 28.2496 193.714C26.0207 193.714 24.2139 195.521 24.2139 197.75C24.2139 199.979 26.0207 201.786 28.2496 201.786Z",
    fill: "#E6E6E6",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.4644 201.786C54.6933 201.786 56.5001 199.979 56.5001 197.75C56.5001 195.521 54.6933 193.714 52.4644 193.714C50.2356 193.714 48.4287 195.521 48.4287 197.75C48.4287 199.979 50.2356 201.786 52.4644 201.786Z",
    fill: "#E6E6E6",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.6783 201.786C78.9072 201.786 80.714 199.979 80.714 197.75C80.714 195.521 78.9072 193.714 76.6783 193.714C74.4494 193.714 72.6426 195.521 72.6426 197.75C72.6426 199.979 74.4494 201.786 76.6783 201.786Z",
    fill: "#E6E6E6",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.893 201.786C103.122 201.786 104.929 199.979 104.929 197.75C104.929 195.521 103.122 193.714 100.893 193.714C98.6643 193.714 96.8574 195.521 96.8574 197.75C96.8574 199.979 98.6643 201.786 100.893 201.786Z",
    fill: "#E6E6E6",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.107 201.786C127.336 201.786 129.143 199.979 129.143 197.75C129.143 195.521 127.336 193.714 125.107 193.714C122.878 193.714 121.071 195.521 121.071 197.75C121.071 199.979 122.878 201.786 125.107 201.786Z",
    fill: "#E6E6E6",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.322 201.786C151.551 201.786 153.358 199.979 153.358 197.75C153.358 195.521 151.551 193.714 149.322 193.714C147.093 193.714 145.286 195.521 145.286 197.75C145.286 199.979 147.093 201.786 149.322 201.786Z",
    fill: "#E6E6E6",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.536 201.786C175.765 201.786 177.571 199.979 177.571 197.75C177.571 195.521 175.765 193.714 173.536 193.714C171.307 193.714 169.5 195.521 169.5 197.75C169.5 199.979 171.307 201.786 173.536 201.786Z",
    fill: "#E6E6E6",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.75 201.786C199.978 201.786 201.785 199.979 201.785 197.75C201.785 195.521 199.978 193.714 197.75 193.714C195.521 193.714 193.714 195.521 193.714 197.75C193.714 199.979 195.521 201.786 197.75 201.786Z",
    fill: "#E6E6E6",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.964 201.786C224.193 201.786 226 199.979 226 197.75C226 195.521 224.193 193.714 221.964 193.714C219.736 193.714 217.929 195.521 217.929 197.75C217.929 199.979 219.736 201.786 221.964 201.786Z",
    fill: "#E6E6E6",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.03571 226C6.26458 226 8.07143 224.193 8.07143 221.964C8.07143 219.735 6.26458 217.928 4.03571 217.928C1.80685 217.928 0 219.735 0 221.964C0 224.193 1.80685 226 4.03571 226Z",
    fill: "#E6E6E6",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2496 226C30.4784 226 32.2853 224.193 32.2853 221.964C32.2853 219.735 30.4784 217.928 28.2496 217.928C26.0207 217.928 24.2139 219.735 24.2139 221.964C24.2139 224.193 26.0207 226 28.2496 226Z",
    fill: "#E6E6E6",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.4644 226C54.6933 226 56.5001 224.193 56.5001 221.964C56.5001 219.735 54.6933 217.928 52.4644 217.928C50.2356 217.928 48.4287 219.735 48.4287 221.964C48.4287 224.193 50.2356 226 52.4644 226Z",
    fill: "#E6E6E6",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.6783 226C78.9072 226 80.714 224.193 80.714 221.964C80.714 219.735 78.9072 217.928 76.6783 217.928C74.4494 217.928 72.6426 219.735 72.6426 221.964C72.6426 224.193 74.4494 226 76.6783 226Z",
    fill: "#E6E6E6",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.893 226C103.122 226 104.929 224.193 104.929 221.964C104.929 219.735 103.122 217.928 100.893 217.928C98.6643 217.928 96.8574 219.735 96.8574 221.964C96.8574 224.193 98.6643 226 100.893 226Z",
    fill: "#E6E6E6",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.107 226C127.336 226 129.143 224.193 129.143 221.964C129.143 219.735 127.336 217.928 125.107 217.928C122.878 217.928 121.071 219.735 121.071 221.964C121.071 224.193 122.878 226 125.107 226Z",
    fill: "#E6E6E6",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.322 226C151.551 226 153.358 224.193 153.358 221.964C153.358 219.735 151.551 217.928 149.322 217.928C147.093 217.928 145.286 219.735 145.286 221.964C145.286 224.193 147.093 226 149.322 226Z",
    fill: "#E6E6E6",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.536 226C175.765 226 177.571 224.193 177.571 221.964C177.571 219.735 175.765 217.928 173.536 217.928C171.307 217.928 169.5 219.735 169.5 221.964C169.5 224.193 171.307 226 173.536 226Z",
    fill: "#E6E6E6",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.75 226C199.978 226 201.785 224.193 201.785 221.964C201.785 219.735 199.978 217.928 197.75 217.928C195.521 217.928 193.714 219.735 193.714 221.964C193.714 224.193 195.521 226 197.75 226Z",
    fill: "#E6E6E6",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.964 226C224.193 226 226 224.193 226 221.964C226 219.735 224.193 217.928 221.964 217.928C219.736 217.928 217.929 219.735 217.929 221.964C217.929 224.193 219.736 226 221.964 226Z",
    fill: "#E6E6E6",
    fillOpacity: 0.2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 226,
    height: 226,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDots);
export default __webpack_public_path__ + "static/media/dots.fc3f8942e4a116380c86be05dc941056.svg";
export { ForwardRef as ReactComponent };